/**
 * Smart home route — redirects `/` to the correct dashboard per user type.
 */

import { Navigate } from 'react-router-dom'
import { RouteLoading } from '@/components/routing/RouteLoading'
import { useAuth } from '@/contexts/AuthContext'
import { useActiveContext } from '@/contexts/ActiveContextProvider'
import { useQAPerspective } from '@/contexts/QAPerspectiveContext'
import { resolveHomeRoute } from '@/lib/routing/resolve-home-route'
import { mapActualRoleToRouteRole } from '@/lib/routing/can-access-route'

export function HomeRedirect() {
  const { accountData, isLoading, isAccountLoading, isAnonymous, session } = useAuth()
  const { activeContext, isLoading: contextLoading } = useActiveContext()
  const { effectiveRole } = useQAPerspective()

  if (isLoading || isAccountLoading || contextLoading) {
    return <RouteLoading />
  }

  if (!session) {
    return <Navigate to="/auth/login" replace />
  }

  const target = resolveHomeRoute({
    role: accountData?.role,
    effectiveRole: mapActualRoleToRouteRole(effectiveRole),
    activeContextScope: activeContext?.scope ?? null,
    isAnonymous,
    isActualAdmin: accountData?.is_admin === true,
  })

  return <Navigate to={target} replace />
}
